import { useState, ReactNode } from 'react';
import { cx } from '@emotion/css';

import { Chip } from '../chip';

export type ChipTabContent = {
  label: string;
  id: string;
  view: ReactNode;
  icon?: string;
};

interface ChipTabsProps {
  className?: string;
  filterLabel?: string;
  defaultActive?: number;
  content: ChipTabContent[];
  fullWidth?: boolean;
}

export const ChipTabs = ({ className, filterLabel, defaultActive, content, fullWidth = false }: ChipTabsProps) => {
  const [activeTab, setActiveTab] = useState<number>(defaultActive ?? 0);

  return (
    <div className={className}>
      {filterLabel && <p className="mb-3 stihl-text-body-default-bold">{filterLabel}</p>}
      <div className={cx('flex gap-2 overflow-x-auto pb-2 desktop:flex-wrap', { 'max-w-2xl': !fullWidth })}>
        {content.map(({ label, id, icon }, index: number) => (
          <Chip
            key={id}
            type="filter"
            className="text-nowrap"
            onSelect={() => setActiveTab(index)}
            selected={label === content[activeTab].label}
            dataTestId={`${id}_chip`}
            icon={icon}
          >
            {label}
          </Chip>
        ))}
      </div>
      {content[activeTab].view}
    </div>
  );
};
